import type { ChallengeDetails } from "../api/getChallenge";
import { sortConditions } from "./sortConditions";

export const evaluateSoloChallenge = ({
    myTeam,
}: {
    myTeam: ChallengeDetails;
}): "missed" | "exceeded" | "dropped" | "success" | "error" => {
    let failureType = "" as "missed" | "exceeded" | "dropped" | "" | "error";
    if (myTeam.wasSuccessful) {
        return "success";
    }
    const sortedConditions = sortConditions(myTeam.conditions);
    while (failureType === "") {
        sortedConditions.forEach((condition) => {
            switch (condition.threshold) {
                case "TARGET":
                    if (condition.currentValue < condition.targetValue) {
                        failureType = "missed";
                    }
                    break;
                case "UPPER_LIMIT":
                    if (condition.currentValue >= condition.targetValue) {
                        failureType = "exceeded";
                    }
                    break;
                case "LOWER_LIMIT":
                    if (condition.currentValue < condition.targetValue) {
                        failureType = "dropped";
                    }
                    break;
            }
        });
        if (failureType === "") failureType = "error";
    }
    return failureType;
};
